__turbopack_context__.v({
  "buyNowButton": "_7YcC2a_buyNowButton" + " " + __turbopack_context__.i(527070)["linkButton"],
  "container": "_7YcC2a_container",
  "productCard": "_7YcC2a_productCard",
  "productCards": "_7YcC2a_productCards" + " " + __turbopack_context__.i(527070)["sectionPadding"],
  "textContent": "_7YcC2a_textContent",
});
